/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  CommercialExecutives,
  CommercialExecutives_commercialExecutives_Users_results_User as CommercialExecutive,
  CommercialExecutivesVariables,
  CommercialExecutives_commercialExecutives_Users_results_User_organizationRole_OrganizationRole_goals_OrganizationUserGoal as CommercialExecutiveGoal,
} from './types/index.graphql'

export const COMMERCIAL_EXECUTIVES = gql`
  query CommercialExecutives($regionId: Int, $includeGoals: Boolean!) {
    commercialExecutives(regionId: $regionId) {
      results {
        id
        name
        lastName
        profilePicture
        regions {
          id
        }
        organizationRole @include(if: $includeGoals) {
          goals {
            id
            yearMonth
            goal
            contributionGoal
          }
        }
      }
    }
  }
`
